import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import CaretUp from "../icons/CaretUp";
import CaretDown from "../icons/CaretDown";

export default function HamburgerMenuExpanded({
  backgroundColor,
  textColor,
  handleExpand,
  tinted = false,
}) {
  const [hamburgerDrop1, setHamburgerDrop1] = useState(false);
  const [hamburgerDrop2, setHamburgerDrop2] = useState(false);
  const [hamburgerDrop3, setHamburgerDrop3] = useState(false);

  const handleHamburgerDrop = (num) => {
    switch (num) {
      case "1":
        setHamburgerDrop1(!hamburgerDrop1);
        break;
      case "2":
        setHamburgerDrop2(!hamburgerDrop2);
        break;
      case "3":
        setHamburgerDrop3(!hamburgerDrop3);
        break;
    }
  };

  // The fade runs on this panel itself (not a wrapper) so its
  // backdrop-filter blur stays visible throughout the fade. Same 0.3s CSS
  // "ease" curve as the page overlay; Navbar.js's AnimatePresence runs the
  // exit fade.
  return (
    <motion.div
      className={`expanded-container ${tinted ? "tinted" : ""}`}
      style={{ background: backgroundColor }}
      transition={{ type: "tween", duration: 0.3, ease: [0.25, 0.1, 0.25, 1] }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="navbar-buttons-expanded">
        <div className="hamburger-dropdown-container">
          <div
            className="hamburger-dropdown-div"
            onClick={() => handleHamburgerDrop("1")}
          >
            <p
              className="link-expanded"
              data-testid="mobile-navbar-link-about"
              style={{ color: textColor, cursor: "default" }}
            >
              About Us
            </p>
            <div className="hamburger-caret-div">
              {hamburgerDrop1 ? (
                <>
                  {" "}
                  <CaretUp className="hamburger-caret" textColor={textColor} />
                </>
              ) : (
                <>
                  <CaretDown
                    textColor={textColor}
                    className="hamburger-caret"
                  />
                </>
              )}
            </div>
          </div>
          {hamburgerDrop1 && (
            <>
              <div className="hamburger-options">
                <Link
                  to="/ourstory"
                  onClick={handleExpand}
                  className="option-expanded"
                  data-testid="mobile-navbar-link-about"
                  style={{ color: textColor }}
                >
                  Our Story
                </Link>
                <Link
                  to="/team"
                  onClick={handleExpand}
                  className="option-expanded"
                  data-testid="mobile-navbar-link-about"
                  style={{ color: textColor }}
                >
                  Our Team
                </Link>
                <Link
                  to="/careers"
                  onClick={handleExpand}
                  className="option-expanded"
                  data-testid="mobile-navbar-link-about"
                  style={{ color: textColor }}
                >
                  Careers
                </Link>
                <Link
                  to="/press"
                  onClick={handleExpand}
                  className="option-expanded"
                  data-testid="mobile-navbar-link-about"
                  style={{ color: textColor }}
                >
                  In The Press
                </Link>
              </div>
            </>
          )}
        </div>

        <div
          className="nav-divider"
          style={{ borderTop: `1px solid ${textColor}` }}
        ></div>

        <div className="hamburger-dropdown-container">
          <div
            className="hamburger-dropdown-div"
            onClick={() => handleHamburgerDrop("2")}
          >
            <p
              className="link-expanded"
              data-testid="mobile-navbar-link-collection"
              style={{ color: textColor, cursor: "default" }}
            >
              The Collection
            </p>
            <div className="hamburger-caret-div">
              {hamburgerDrop2 ? (
                <>
                  {" "}
                  <CaretUp
                    textColor={textColor}
                    className="hamburger-caret"
                    size={20}
                  />
                </>
              ) : (
                <>
                  <CaretDown
                    textColor={textColor}
                    className="hamburger-caret"
                    size={20}
                  />
                </>
              )}
            </div>
          </div>
          {hamburgerDrop2 && (
            <>
              <div className="hamburger-options">
                <Link
                  to="/portfolio"
                  onClick={handleExpand}
                  className="option-expanded"
                  data-testid="mobile-navbar-link-about"
                  style={{ color: textColor }}
                >
                  Portfolio
                </Link>
                <a
                  href="https://corsoresidences.com/"
                  target="_blank"
                  rel="noreferrer"
                  onClick={handleExpand}
                  className="option-expanded"
                  data-testid="mobile-navbar-link-about"
                  style={{ color: textColor }}
                >
                  Corso Residences
                </a>
                <a
                  href="https://villageparkseniorliving.com/"
                  target="_blank"
                  rel="noreferrer"
                  onClick={handleExpand}
                  className="option-expanded"
                  data-testid="mobile-navbar-link-about"
                  style={{ color: textColor }}
                >
                  Village Park
                </a>
              </div>
            </>
          )}
        </div>

        <div
          className="nav-divider"
          style={{ borderTop: `1px solid ${textColor}` }}
        ></div>

        <div className="hamburger-dropdown-container">
          <div
            className="hamburger-dropdown-div"
            onClick={() => handleHamburgerDrop("3")}
          >
            <p
              className="link-expanded"
              data-testid="mobile-navbar-link-companies"
              style={{ color: textColor, cursor: "default" }}
            >
              Our Companies
            </p>
            <div className="hamburger-caret-div">
              {hamburgerDrop3 ? (
                <>
                  {" "}
                  <CaretUp
                    textColor={textColor}
                    className="hamburger-caret"
                    size={20}
                  />
                </>
              ) : (
                <>
                  <CaretDown
                    textColor={textColor}
                    className="hamburger-caret"
                    size={20}
                  />
                </>
              )}
            </div>
          </div>
          {hamburgerDrop3 && (
            <>
              <div className="hamburger-options">
                <Link
                  to="/management"
                  onClick={handleExpand}
                  className="option-expanded"
                  data-testid="mobile-navbar-link-about"
                  style={{ color: textColor }}
                >
                  Galerie Management
                </Link>
                <Link
                  to="/development"
                  onClick={handleExpand}
                  className="option-expanded"
                  data-testid="mobile-navbar-link-about"
                  style={{ color: textColor }}
                >
                  Galerie Development
                </Link>
                <Link
                  to="/capital"
                  onClick={handleExpand}
                  className="option-expanded"
                  data-testid="mobile-navbar-link-about"
                  style={{ color: textColor }}
                >
                  Galerie Capital
                </Link>
              </div>
            </>
          )}
        </div>

        <div
          className="nav-divider"
          style={{ borderTop: `1px solid ${textColor}` }}
        ></div>

        <Link
          to="/contact"
          onClick={handleExpand}
          className="contact-us-btn"
          data-testid="mobile-navbar-link-contact"
          style={{ color: textColor, textDecoration: "none" }}
        >
          Contact Us
        </Link>
      </div>
    </motion.div>
  );
}
